// extracted by mini-css-extract-plugin
export default {"printable":"Product_printable__qi2vi","wrapper":"Product_wrapper__pdlNa","container":"Product_container__QSfFJ","volumes":"Product_volumes__2vXau"};